<template>
  <div class="smartcard">
    <div class="card-header bg-default">
      {{ trailingRebatePromo.companyName }}
    </div>
    <div class="list-group list-group-flush">
      <div class="list-group-item">
        <strong>Promo Code</strong><br/>{{ trailingRebatePromo.PromoCode.code }}
      </div>
      <div class="list-group-item">
        <strong>Description</strong><br/>{{ trailingRebatePromo.PromoCode.description }}
      </div>
      <div class="list-group-item">
        <template v-if="trailingRebatePromo.PromoCode.type === 'waivedFee'">
          <span class="badge badge-success"><span class="fa fa-ban"></span></span> Waived Fee <br />
        </template>
        <span v-if="trailingRebatePromo.percentRebate > 0">
          <strong>Trailing Rebate:</strong> {{ trailingRebatePromo.percentRebate }}%
        </span>
      </div>
      <div class="list-group-item">
        <strong>Expiration Type:</strong>
        <template v-if="trailingRebatePromo.PromoCode.expirationType === 'scheduled'">
          <span class="fa fa-calendar-alt"></span> Scheduled ({{ trailingRebatePromo.PromoCode.startDate | short_date_format }} - {{ trailingRebatePromo.PromoCode.endDate | short_date_format }})
        </template>
        <template v-if="trailingRebatePromo.PromoCode.expirationType === 'permanent'">
          <span class="fa fa-asterisk"></span> Permanent
        </template>
        <template v-if="trailingRebatePromo.PromoCode.expirationType === 'limitedUse'">
          <span class="fa fa-ban"></span> Limited Use ({{ trailingRebatePromo.PromoCode.usageLimit }} uses)
        </template>
      </div>
    </div>
    <div class="card-footer text-right">
      <router-link class="btn btn-sm btn-primary"
      :to="{ path: `/membership/trailing-rebate-promotions/view/${trailingRebatePromo.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> View Details
      </router-link>
      <router-link class="btn btn-sm btn-primary"
      :to="{ path: `/membership/trailing-rebate-promotions/edit/${trailingRebatePromo.uuid}` }">
        <span class="fa fa-edit fa-fw"></span> Edit
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TrailingRebatePromo',
  props: {
    object: {
      type: Object
    }
  },
  computed: {
    trailingRebatePromo () {
      return {
        uuid: '',
        companyName: '',
        PromoCode: {
          code: '',
          description: '',
          startDate: new Date(),
          endDate: new Date(),
          expirationType: '',
          usageLimit: 0
        },
        type: '',
        percentRebate: '',
        OrganizationUuid: '',
        ...this.object
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/cards/TrailingRebatePromo.vue